export default "__VITE_ASSET__0f5d665f__"